import { Campaign, GroupCampaign } from '@/models/reward';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgRewardExtrasGroupCampaignOptionCard',
})

export default class CmgRewardExtrasGroupCampaignOptionCard extends Vue {

  @Prop({ required: true, type: Object })
  campaign!: Campaign;

  @Prop({ required: true, type: Object })
  groupCampaign!: GroupCampaign;

  get titleText(): string {
    return this.campaign.title.toUpperCase();
  }

  get descriptionText(): string {
    return this.campaign.description;
  }

  get extraPoints(): number {
    return this.campaign.extraPoints;
  } 

  get medallionBackgroundUrl(): string {
    if (this.campaign.medallionText) {
      return this.$appStore.state.cms.images.backgrounds.pointsMultiplier.default;
    } else {
      return this.$appStore.state.cms.images.backgrounds.pointsEarned.default;
    }
  }

  onClickCampaignCard() {
    this.$emit('campaignIdSelected', this.campaign.id);
  }

  onClickTermsAndConditions() {
    const campaign = this.campaign;
    const groupCampaign = this.groupCampaign;
    const onBack = () => {
      this.$services.ui.setModalVisibility('rewardExtrasGroupCampaignDetail', true, { groupCampaign });
      this.$services.ui.setModalVisibility('rewardTermsAndConditions', false);
    };

    this.$services.ui.setModalVisibility('rewardTermsAndConditions', true, { termsAndConditions: this.campaign.terms, onBack });
    this.$services.ui.setModalVisibility('rewardExtrasGroupCampaignDetail', false);
  }
}